module.exports = __webpack_public_path__ + "static/nature-8fd9426aa15ff9daea63d2e71a3eb6e2.jpg";